import makeApiCall from "../master/axiosIndex";

const inventoryCreation = {
  fetchSiteInventory: (
    sortOrder: any,
    pageSize: any,
    direction: any,
    pageDiff: any,
    paginationId: any,
    siteId: any,
    categoryId: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/siteInventory/list",
      params: {
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        siteId,
        categoryId,
      },
    }),
  fetchSiteInventoryPagiantion: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/inventory/siteInventory/list",
      method: "get",
      params,
    }),
  fetchMaterialIssue: (
    sortOrder: any,
    pageSize: any,
    direction: any,
    pageDiff: any,
    paginationId: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialIssue/list",
      params: { sortOrder, pageSize, direction, pageDiff, paginationId },
    }),
  fetchPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialIssue/pendingApprovals",
      params,
    }),
  createSiteIssue: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/inventory/materialIssue/new",
      data,
    }),
  fetchViewMaterialDetails: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/inventory/materialIssue/id/${id}`,
      // params:id
    }),
  approve: (materialIssueId: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/inventory/materialIssue/approve`,
      data: { materialIssueId },
    }),
  reject: (materialIssueId: any, reason: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/inventory/materialIssue/reject`,
      data: { materialIssueId, reason },
    }),
};

export default inventoryCreation;
